import { Checkbox } from "primereact/checkbox";
import MyInput from "../../../components/ui/MyInput";
import { useEffect, useState } from "react";
import CreateAction from "../../../components/operational/createAction";
import PrimaryButton from "../../../components/ui/PrimaryButton";


const BillingMain = ({ error, formButtonRef, callback }) => {

    const [billing, setBilling] = useState({
        isBusiness: false
    })

    const onSave = async () => {
        const response = await CreateAction({
            method: 'patch',
            path: `/billing`,
            showPreLoader: true,
            isFileUploading: false,
            data: billing
        });
        callback?.(response)
    }


    const onBillingInformationChange = (key, value) => {
        setBilling(state => ({ ...state, [key]: value }))
    }


    const getBilling = async () => {
        const response = await CreateAction({
            method: 'get',
            path: `/billing`,
            showPreLoader: true,
            isFileUploading: false,
        });

        if (response?.error) return
        setBilling(response?.result?.resultData?.data || {})
    }

    useEffect(() => {
        getBilling()
    }, [])
    return (

        <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto gap-[20px]">
            <form className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%] flex flex-col gap-[15px]"
                onSubmit={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    onSave()
                }}

            >
                <div className="flex align-items-center flex-row items-center">
                    <Checkbox inputId="isBusiness" name="isBusiness" value="isBusiness" checked={billing.isBusiness} onChange={(e) => onBillingInformationChange("isBusiness", e?.target?.checked)} />
                    <label for="isBusiness" className="ml-2 text-[15px] select-none ">Kurumsal fature almak istiyorum.</label>
                </div>
                {billing?.isBusiness ?
                    <>
                        <MyInput value={billing.companyName} onChange={(e) => onBillingInformationChange("companyName", e)} isRequired label={"Şirket Adı *"} ></MyInput>
                        <div className="flex flex-row gap-[15px]">
                            <MyInput value={billing.taxNumber} onChange={(e) => onBillingInformationChange("taxNumber", e)} isRequired label={"Vergi Numarası *"} ></MyInput>
                            <MyInput value={billing.taxOffice} onChange={(e) => onBillingInformationChange("taxOffice", e)} isRequired label={"Vergi Daires *"} ></MyInput>
                        </div>
                    </> :
                    <>
                        <div className="flex flex-row gap-[15px]">
                            <MyInput value={billing.name} onChange={(e) => onBillingInformationChange("name", e)} isRequired label={"Ad *"} ></MyInput>
                            <MyInput value={billing.surname} onChange={(e) => onBillingInformationChange("surname", e)} isRequired label={"Soyad *"} ></MyInput>
                        </div>
                        <MyInput value={billing.tckn} onChange={(e) => onBillingInformationChange("tckn", e)} label={"TC Kimlik No"} ></MyInput>
                    </>

                }
                <MyInput value={billing.adress} onChange={(e) => onBillingInformationChange("adress", e)} isRequired label={"Adres *"} ></MyInput>

                <div className="flex flex-row gap-[15px]">
                    <MyInput value={billing.adress2} onChange={(e) => onBillingInformationChange("adress2", e)} label={"Adres 2"} ></MyInput>
                    <MyInput value={billing.postalCode} onChange={(e) => onBillingInformationChange("postalCode", e)} label={"Posta Kodu"} ></MyInput>
                </div>
                <MyInput value={billing.country} onChange={(e) => onBillingInformationChange("country", e)} isRequired label={"Ülke *"} ></MyInput>
                <div className="flex flex-row gap-[15px]">
                    <MyInput value={billing.city} onChange={(e) => onBillingInformationChange("city", e)} isRequired label={"Şehir *"} ></MyInput>
                    <MyInput value={billing.county} onChange={(e) => onBillingInformationChange("county", e)} isRequired label={"İlçe *"} ></MyInput>
                </div>
                <button className="hidden" ref={formButtonRef} type="submit" ></button>
            </form>
        </div>



    );
};

export default BillingMain;
